
import DiscussionsWidgetComponent from '../../../../../../ManagementApp/wwwroot/client/src/views/components/DiscussionsWidget.vue';

export const DiscussionsWidget = DiscussionsWidgetComponent;
export default DiscussionsWidgetComponent;
